(() => {
  const section = document.querySelector("[data-onura-header-section]");
  const desktopHeader = document.querySelector("[data-onura-desktop-header]");
  const mobileHeader = document.querySelector("[data-onura-mobile-header]");
  const mobileDrawer = document.querySelector("[data-onura-mobile-drawer]");
  const menuToggle = document.querySelector("[data-onura-menu-toggle]");
  const menuLabel = document.querySelector("[data-onura-menu-label]");
  const cartCountNodes = document.querySelectorAll("[data-onura-cart-count]");
  const localizationSelects = document.querySelectorAll("[data-onura-localization-select]");
  const submenuToggles = document.querySelectorAll("[data-onura-submenu-toggle]");
  const desktopMenus = document.querySelectorAll("[data-onura-desktop-menu]");
  const localizationDropdowns = document.querySelectorAll("[data-onura-localization-dropdown]");
  const MOBILE_HOME_COLOR_THRESHOLD = 900;

  if (!section) return;

document.addEventListener("click", (event) => {
  const cartTrigger = event.target.closest("[data-onura-cart-trigger]");

  if (!cartTrigger) return;

  const cartDrawer = document.querySelector("cart-drawer");

  if (!cartDrawer || typeof cartDrawer.open !== "function") {
    return;
  }

  event.preventDefault();
  cartDrawer.open(cartTrigger);
});

  const desktopBreakpoint = window.matchMedia("(min-width: 990px)");
  let lastScrollY = window.scrollY || 0;
  let ticking = false;
  let isMobileMenuOpen = false;

  const DESKTOP_SCROLL_THRESHOLD = 680;
  const DESKTOP_TOP_THRESHOLD = 80;

  const setCartCount = (count) => {
    const safeCount = Number.isFinite(Number(count)) ? Number(count) : 0;

    cartCountNodes.forEach((node) => {
      node.textContent = String(safeCount);
      node.classList.toggle("is-empty", safeCount === 0);
      node.setAttribute("aria-label", `${safeCount} items in cart`);
    });
  };

  const refreshCartCount = async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
        method: "GET",
        credentials: "same-origin",
        headers: {
          Accept: "application/json"
        }
      });

      if (!response.ok) return;

      const cart = await response.json();
      setCartCount(cart.item_count);
    } catch (error) {
      return;
    }
  };

  const handleDesktopScroll = () => {
    if (!desktopHeader) return;

    const currentScrollY = window.scrollY || 0;
    const isScrollingUp = currentScrollY < lastScrollY;
    const isAtTop = currentScrollY <= DESKTOP_TOP_THRESHOLD;
    const isBeforeThreshold = currentScrollY <= DESKTOP_SCROLL_THRESHOLD;

    desktopHeader.classList.toggle("is-at-page-top", isAtTop);

    if (isAtTop) {
      desktopHeader.classList.remove("is-in-pre-threshold", "is-scroll-hidden", "is-scroll-visible");
    } else if (isBeforeThreshold) {
      desktopHeader.classList.add("is-in-pre-threshold");
      desktopHeader.classList.remove("is-scroll-hidden", "is-scroll-visible");
    } else if (isScrollingUp) {
      desktopHeader.classList.add("is-scroll-visible");
      desktopHeader.classList.remove("is-scroll-hidden", "is-in-pre-threshold");
    } else {
      desktopHeader.classList.add("is-scroll-hidden");
      desktopHeader.classList.remove("is-scroll-visible", "is-in-pre-threshold");
    }

    lastScrollY = Math.max(currentScrollY, 0);
    ticking = false;
  };

const requestScrollTick = () => {
  updateMobileHomeHeaderState();

  if (!desktopBreakpoint.matches) return;

  if (!ticking) {
    window.requestAnimationFrame(handleDesktopScroll);
    ticking = true;
  }
};

  const openMobileMenu = () => {
    if (!mobileDrawer || !menuToggle || !menuLabel) return;

    isMobileMenuOpen = true;

    section.classList.add("is-mobile-menu-open");
    document.documentElement.classList.add("onura-mobile-menu-lock");
    document.body.classList.add("onura-mobile-menu-lock");

    menuToggle.setAttribute("aria-expanded", "true");
    mobileDrawer.setAttribute("aria-hidden", "false");
    menuLabel.textContent = "Close";
  };

  const closeMobileMenu = () => {
    if (!mobileDrawer || !menuToggle || !menuLabel) return;

    isMobileMenuOpen = false;

    section.classList.remove("is-mobile-menu-open");
    document.documentElement.classList.remove("onura-mobile-menu-lock");
    document.body.classList.remove("onura-mobile-menu-lock");

    menuToggle.setAttribute("aria-expanded", "false");
    mobileDrawer.setAttribute("aria-hidden", "true");
    menuLabel.textContent = "Menu";

    submenuToggles.forEach((button) => {
      button.setAttribute("aria-expanded", "false");
    });

    mobileDrawer.querySelectorAll("[data-onura-submenu]").forEach((submenu) => {
      submenu.classList.remove("is-open");
      submenu.setAttribute("aria-hidden", "true");
      submenu.setAttribute("inert", "");
    });
  };

  const toggleMobileMenu = () => {
    if (isMobileMenuOpen) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  };

  const bindMobileMenu = () => {
    if (!menuToggle) return;

    menuToggle.addEventListener("click", toggleMobileMenu);

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && isMobileMenuOpen) {
        closeMobileMenu();
      }
    });

    if (mobileDrawer) {
      const drawerLinks = mobileDrawer.querySelectorAll("a[href]");
      drawerLinks.forEach((link) => {
        link.addEventListener("click", () => {
          closeMobileMenu();
        });
      });
    }
  };

  const bindMobileSubmenus = () => {
    submenuToggles.forEach((button) => {
      const submenuId = button.getAttribute("aria-controls");
      const submenu = submenuId ? document.getElementById(submenuId) : null;

      if (!submenu) return;

      button.addEventListener("click", () => {
        const isOpen = button.getAttribute("aria-expanded") === "true";

        button.setAttribute("aria-expanded", String(!isOpen));
        submenu.classList.toggle("is-open", !isOpen);
        submenu.setAttribute("aria-hidden", String(isOpen));
        submenu.toggleAttribute("inert", isOpen);

        if (isOpen) {
          submenu.querySelectorAll("[data-onura-submenu-toggle]").forEach((nestedButton) => {
            nestedButton.setAttribute("aria-expanded", "false");
          });

          submenu.querySelectorAll("[data-onura-submenu]").forEach((nestedSubmenu) => {
            nestedSubmenu.classList.remove("is-open");
            nestedSubmenu.setAttribute("aria-hidden", "true");
            nestedSubmenu.setAttribute("inert", "");
          });
        }
      });
    });
  };

  const bindDesktopMenus = () => {
    desktopMenus.forEach((menu) => {
      const trigger = menu.querySelector("[data-onura-desktop-menu-trigger]");
      const content = menu.querySelector("[data-onura-desktop-menu-content]");

      if (!trigger || !content) return;

      const setOpen = (isOpen) => {
        menu.classList.toggle("is-open", isOpen);
        trigger.setAttribute("aria-expanded", String(isOpen));
      };

      menu.addEventListener("pointerenter", () => setOpen(true));
      menu.addEventListener("pointerleave", () => {
        if (!menu.contains(document.activeElement)) setOpen(false);
      });
      menu.addEventListener("focusin", () => setOpen(true));
      menu.addEventListener("focusout", () => {
        window.setTimeout(() => {
          if (!menu.contains(document.activeElement)) setOpen(false);
        }, 0);
      });
      menu.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") return;

        setOpen(false);
        trigger.focus();
      });
    });
  };

const bindLocalization = function () {
  localizationSelects.forEach(function (select) {
    select.addEventListener("change", function () {
      const form = select.closest("form");

      if (form) {
        form.submit();
      }
    });
  });

  localizationDropdowns.forEach(function (dropdown) {
    const toggle = dropdown.querySelector("[data-onura-localization-toggle]");
    const content = dropdown.querySelector("[data-onura-localization-content]");
    const countryInput = dropdown.querySelector("[data-onura-country-input]");
    const countryOptions = dropdown.querySelectorAll("[data-onura-country-option]");

    if (!toggle || !content) return;

    const closeDropdown = function () {
      dropdown.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
    };

    const openDropdown = function () {
      dropdown.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
    };

    const toggleDropdown = function () {
      if (dropdown.classList.contains("is-open")) {
        closeDropdown();
      } else {
        openDropdown();
      }
    };

    toggle.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      toggleDropdown();
    });

    content.addEventListener("click", function (event) {
      event.stopPropagation();
    });

    countryOptions.forEach(function (button) {
      button.addEventListener("click", function () {
        const countryCode = button.getAttribute("data-country-code");
        const form = button.closest("form");

        if (!countryCode || !countryInput || !form) return;

        countryInput.value = countryCode;
        form.submit();
      });
    });

    document.addEventListener("click", closeDropdown);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeDropdown();
      }
    });
  });
};

  const bindCartUpdates = () => {
    setCartCount(Number(cartCountNodes[0]?.textContent || 0));

    document.addEventListener("cart:updated", refreshCartCount);
    document.addEventListener("cart:refresh", refreshCartCount);
    document.addEventListener("onura:cart:update", refreshCartCount);

    document.addEventListener("submit", (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;

      const action = form.getAttribute("action") || "";

      if (action.includes("/cart/add")) {
        window.setTimeout(refreshCartCount, 700);
      }
    });

    document.addEventListener("click", (event) => {
      const target = event.target;

      if (!(target instanceof Element)) return;

      const cartTrigger = target.closest('[name="add"], [data-add-to-cart], .product-form__submit, cart-remove-button, [data-cart-remove]');

      if (cartTrigger) {
        window.setTimeout(refreshCartCount, 700);
        window.setTimeout(refreshCartCount, 1400);
      }
    });

    if (window.fetch) {
      const originalFetch = window.fetch;

      window.fetch = async (...args) => {
        const response = await originalFetch(...args);

        try {
          const requestUrl = typeof args[0] === "string" ? args[0] : args[0]?.url || "";

          if (
            requestUrl.includes("/cart/add") ||
            requestUrl.includes("/cart/change") ||
            requestUrl.includes("/cart/update") ||
            requestUrl.includes("/cart/clear")
          ) {
            window.setTimeout(refreshCartCount, 350);
          }
        } catch (error) {
          return response;
        }

        return response;
      };
    }

    refreshCartCount();
  };

const handleViewportChange = () => {
  if (desktopBreakpoint.matches) {
    closeMobileMenu();
    handleDesktopScroll();
  }

  updateMobileHomeHeaderState();
};

  const updateMobileHomeHeaderState = () => {
  if (!section.classList.contains("is-homepage")) return;

  const isMobile = !desktopBreakpoint.matches;
  const isAtTopZone = (window.scrollY || 0) < MOBILE_HOME_COLOR_THRESHOLD;

  section.classList.toggle("is-mobile-home-top", isMobile && isAtTopZone);
};

  window.addEventListener("scroll", requestScrollTick, { passive: true });
  window.addEventListener("resize", handleViewportChange);
  desktopBreakpoint.addEventListener?.("change", handleViewportChange);

  bindMobileMenu();
  bindMobileSubmenus();
  bindDesktopMenus();
  bindLocalization();
  bindCartUpdates();
  handleDesktopScroll();
  updateMobileHomeHeaderState();
})();

